// @TODO: a lot of this can be abstracted away
/**
 * Ryan O'Dowd
 * 2025-02-09
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  TouchableOpacity,
  View,
} from 'react-native';
import Icon from '@react-native-vector-icons/material-design-icons';
import ListItem from '@components/ListItem';
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const TypeItem = (props: TypeItemProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <ListItem
      containerStyles={styles.container}
      variant='primary'
      disabled={true}
    >
      <View style={styles.row}>{/* @TODO: a lot of these styles don't actually exist */}
        <View style={styles.textWrapper}>
          <Text style={styles.titleText}>{props.title}</Text>
          <View style={styles.descriptionWrapper}>
            <Text style={styles.descriptionText}>{props.description}</Text>
          </View>
        </View>
        <View style={styles.rightActions}>
          <View style={styles.cellAndTextWrapper}>
            <TouchableOpacity
              style={styles.cellIconWrapper(props.pushStatus)}
              onPress={() => props.pushToggle()}
            >
              <Icon
                style={styles.cellIcon(props.pushStatus)}
                name='cellphone'
                size={24}
              />
            </TouchableOpacity>
            <Text style={styles.typeText(props.pushStatus)}>Mobile</Text>
          </View>
          {/* @TODO:
          <View style={styles.cellAndTextWrapper}>
            <TouchableOpacity
              style={styles.cellIconWrapper(props.emailStatus)}
              onPress={() => props.emailToggle()}
            >
              <Icon
                style={styles.cellIcon(props.emailStatus)}
                name='email'
                size={24}
                color={props.emailStatus ? styles.colors.accent : styles.colors.primaryDark}
              />
            </TouchableOpacity>
            <Text style={styles.typeText(props.emailStatus)}>Email</Text>
          </View>
          */}
          {/* @TODO: add sms as well */}
        </View>
      </View>
      {!!props.children &&
        <View style={styles.actionsRow}>
          {props.children}
        </View>
      }
    </ListItem>
  );
};

class TypeItemProps {
  title: string;
  description: string;
  pushStatus: boolean;
  pushToggle: () => void;

  children?: React.ReactNode;
  emailStatus?: boolean;
  emailToggle?: () => void;
};

export default TypeItem;
